import { z } from 'zod';

export const generalRuleKeys = [
  'documentCreate',
  'documentDisable',
  'userCreate',
  'userDisable',
  'processCreate',
  'processDisable',
  'structureProcessCreate',
  'structureProcessDisable',
] as const;

export type GeneralRuleKey = (typeof generalRuleKeys)[number];

export const generalRuleKeySchema = z.enum(generalRuleKeys);

export const generalRulesDtoSchema = z.object({
  userId: z.string().uuid(),
  documentCreate: z.boolean(),
  documentDisable: z.boolean(),
  userCreate: z.boolean(),
  userDisable: z.boolean(),
  processCreate: z.boolean(),
  processDisable: z.boolean(),
  structureProcessCreate: z.boolean(),
  structureProcessDisable: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const updateGeneralRulesSchema = z
  .object({
    documentCreate: z.boolean().optional(),
    documentDisable: z.boolean().optional(),
    userCreate: z.boolean().optional(),
    userDisable: z.boolean().optional(),
    processCreate: z.boolean().optional(),
    processDisable: z.boolean().optional(),
    structureProcessCreate: z.boolean().optional(),
    structureProcessDisable: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, {
    message: 'Au moins une règle doit être fournie',
  });

export type GeneralRulesDto = z.infer<typeof generalRulesDtoSchema>;
export type UpdateGeneralRulesInput = z.infer<typeof updateGeneralRulesSchema>;
